'use client'
import {Button} from "@/components/ui/button"
import {ChevronDown, Menu, Sparkles} from "lucide-react"
import Image from "next/image"
import Link from "next/link"
import {
    Sheet,
    SheetContent,
    SheetDescription,
    SheetHeader,
    SheetTitle,
    SheetTrigger,
} from "@/components/ui/sheet"
import {usePathname} from "next/navigation"
import upgradLogo from "@/assets/logo/upgrad-logo.png"
import UpgradLogo from "@/assets/logo/upgrad";
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuLabel,
    DropdownMenuSeparator,
    DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"
import useScroll from "@/lib/hooks/useScroll";
import {useAppSelector} from "@/lib/hooks/store";
import {getAuth, getUser} from "@/lib/store/features/user/selectors";

const Header = ({transparent, isBlackText}: { transparent: boolean, isBlackText: boolean }) => {
    const user = useAppSelector(getUser)
    const pathname = usePathname()
    const scrollPosition = useScroll()
    const menus = [
        {name: "Trang chủ", path: '/', desktop: true},
        // {name: "Abroad", path: '/bussiness', desktop: true},
        // {name: "Courses", path: '/course', desktop: true},
        // {name: "Explorer", path: '/explorer', desktop: true},
        // {name: "Referral", path: '/referral', desktop: true},
        {name: "Blog", path: '/blog', desktop: true},
        {name: "Chính sách", path: '/term', desktop: true},
        // {name: "FAQ", path: '/faq', desktop: true},
        {name: "Help Center", path: '/help-center', desktop: true},
        {name: "Về Finsey", path: '/about', desktop: true},
    ]

    return (
        <div
            className={`width-full transition-all duration-500 ${transparent ? scrollPosition < 250 ? 'bg-transparent' : 'bg-white shadow-md' : 'bg-white shadow-md'}`}>
            <div className="container flex flex-row justify-between items-center">
                <Link href={'/'}>
                    <Image
                        src={transparent && !isBlackText ? scrollPosition < 250 ? '/global/logo-white.png' : '/global/logo.png' : '/global/logo.png'}
                        width={'60'} height={'60'} alt="finsey-logo"/>
                </Link>
                <div className="hidden md:flex flex-row justify-between items-center gap-4">
                    {/*<DropdownMenu>*/}
                    {/*    <DropdownMenuTrigger className='bg-finsey-old border-2 border-finsey-old text-white rounded-md text-sm h-10 px-4 py-2 flex justify-center items-center'>Du học <ChevronDown strokeWidth={1.5} className='size-4' /></DropdownMenuTrigger>*/}
                    {/*    <DropdownMenuContent>*/}
                    {/*        <DropdownMenuItem className='text-center justify-center'>*/}
                    {/*            <Link href={'/partner/upgrad'}><UpgradLogo width='70px' /></Link>*/}
                    {/*        </DropdownMenuItem>*/}
                    {/*    </DropdownMenuContent>*/}
                    {/*</DropdownMenu>*/}
                    {
                        menus.map((item, index) => {
                            if (item.desktop) {
                                return (
                                    <Link key={index}
                                          className={`${item.path == pathname ? 'text-primary' : transparent && !isBlackText ? scrollPosition < 250 ? 'text-white' : 'text-black' : 'text-black'}`}
                                          href={item.path}>{item.name}</Link>
                                )
                            }
                        })
                    }
                    {
                        !user?.email ? (
                            <Link href={'/sign-in'}><Button>Đăng nhập</Button></Link>
                        ) : (
                            <Link href={'/account/overview'}><Button>Tài khoản</Button></Link>
                        )
                    }
                    {/*<Link href={'/login'}><Button className="bg-white border-2 border-primary text-primary">Tra cứu</Button></Link>*/}
                </div>
                <div className="flex flex-row justify-between items-cente md:hidden">
                    <Sheet>
                        <SheetTrigger><Menu/></SheetTrigger>
                        <SheetContent className="w-[50%]">
                            <SheetHeader>
                                <SheetTitle className="mb-5 text-lg">Menu</SheetTitle>
                                <SheetDescription className="w-full flex flex-col justify-start items-center gap-3">
                                    {
                                        menus.map((item, index) => {
                                            return (
                                                <Link key={index}
                                                      className={`text-lg ${item.path == pathname ? 'text-primary' : 'text-black'}`}
                                                      href={item.path}>{item.name}</Link>
                                            )
                                        })
                                    }
                                    {
                                        !user?.email ? (
                                            <Link href={'/sign-in'} className="w-full"><Button className="w-full">Đăng
                                            nhập</Button></Link>
                                        ) : (
                                            <Link href={'/account/overview'} className="w-full"><Button className="w-full">Tài khoản</Button></Link>
                                        )
                                    }

                                    {/*<Link href={'/login'} className="w-full"><Button*/}
                                    {/*    className="w-full bg-white border-2 border-primary text-primary">Tra*/}
                                    {/*    cứu</Button></Link>*/}
                                    {/*<Link href={'/partner/upgrad'} className='w-full'><Button className='w-full shadow-custom bg-white'><UpgradLogo width='70px' /></Button></Link>*/}
                                </SheetDescription>
                            </SheetHeader>
                        </SheetContent>
                    </Sheet>
                </div>
            </div>
        </div>
    )
}

export default Header